import { useEffect, useState } from "react"

interface UseButtonMultiSelectProps {
  options: Array<{ title: string; id: string }>
  defaultValues: Array<string>
}

export default function useButtonMultiSelect({ options, defaultValues = [] }: UseButtonMultiSelectProps) {
  const [valid] = useState(true)
  const [selected, setSelected] = useState([])

  useEffect(() => {
    const allSelectedValues = options.map(({ id }) => (defaultValues.includes(id) ? id : null)).filter(Boolean)
    setSelected(allSelectedValues)
  }, [])

  function onClick(selectedValue): void {
    const indexOfSelection = selected.findIndex((id) => id === selectedValue)
    if (indexOfSelection >= 0) {
      const newArray = [...selected]
      newArray.splice(indexOfSelection, 1)
      setSelected(newArray)
    } else {
      setSelected([...selected, selectedValue])
    }
  }

  return { options, valid, multiSelected: selected, onClick }
}
